export const NAV_LINKS = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Users", path: "/users" },
  { label: "Players", path: "/players" },
  { label: "Plans", path: "/plans" },
  { label: "User Plans", path: "/user-plans" },
  { label: "Matches", path: "/matches" },
  { label: "Sports", path: "/sports" },
  { label: "Live TV", path: "/livetv" },
  { label: "Activate TV", path: "/activate-tv" },
  { label: "Notifications", path: "/notifications" },
  { label: "Reports", path: "/reports" },
  { label: "Star Players", path: "/star-players" },
  { label: "Podcasts", path: "/podcasts" },
  { label: "Legal", path: "/legal" },
  { label: "Sub Admins", path: "/sub-admins" },
  { label: "Social Media", path: "/social-media" },
  { label: "Popups", path: "/popup" },
  { label: "Settings", path: "/settings" }
];

export const PAGE_TITLES = {
  "/dashboard": "Dashboard",
  "/users": "Users",
  "/players": "Players",
  "/teams": "Teams",
  "/series": "Series",
  "/plans": "Plans",
  "/user-plans": "User Plans",
  "/matches": "Matches",
  "/sports": "Sports",
  "/livetv": "Live TV",
  "/activate-tv": "Activate TV",
  "/notifications": "Notifications",
  "/reports": "Reports",
  "/star-players": "Star Players",
  "/match-highlights": "Match Highlights",
  "/podcasts": "Podcasts",
  "/legal": "Legal Pages",
  "/sub-admins": "Sub Admins",
  "/social-media": "Social Media Links",
  "/popup": "Popups",
  "/settings": "Settings"
};

export const STATUS_STYLES = {
  active: "bg-emerald-100 text-emerald-700 border border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-400 dark:border-emerald-500/20",
  pending: "bg-amber-100 text-amber-700 border border-amber-200 dark:bg-amber-500/15 dark:text-amber-400 dark:border-amber-500/20",
  inactive: "bg-slate-100 text-slate-700 border border-slate-200 dark:bg-slate-500/15 dark:text-slate-400 dark:border-slate-500/20",
  live: "bg-rose-100 text-rose-700 border border-rose-200 dark:bg-rose-500/15 dark:text-rose-400 dark:border-rose-500/20",
  maintenance: "bg-amber-100 text-amber-700 border border-amber-200 dark:bg-amber-500/15 dark:text-amber-400 dark:border-amber-500/20",
  completed: "bg-indigo-100 text-indigo-700 border border-indigo-200 dark:bg-indigo-500/15 dark:text-indigo-400 dark:border-indigo-500/20",
  upcoming: "bg-violet-100 text-violet-700 border border-violet-200 dark:bg-violet-500/15 dark:text-violet-400 dark:border-violet-500/20",
  scheduled: "bg-violet-100 text-violet-700 border border-violet-200 dark:bg-violet-500/15 dark:text-violet-400 dark:border-violet-500/20",
  ended: "bg-slate-100 text-slate-700 border border-slate-200 dark:bg-slate-500/15 dark:text-slate-400 dark:border-slate-500/20",
  offline: "bg-slate-100 text-slate-700 border border-slate-200 dark:bg-slate-500/15 dark:text-slate-400 dark:border-slate-500/20",
  failed: "bg-amber-100 text-amber-700 border border-amber-200 dark:bg-amber-500/15 dark:text-amber-400 dark:border-amber-500/20"
};

export const ITEMS_PER_PAGE = 7;
